import {createStore,applyMiddleware} from 'redux'
import ReduxThunk from 'redux-thunk'
import rootReducer from '../reducers/index'

export const middleware = [ReduxThunk]
export const createStoreMiddlewares = applyMiddleware(...middleware)(createStore)
export const store = createStoreMiddlewares(rootReducer)
